"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BestLabelWithRight = _interopRequireDefault(require("../elements/BestLabelWithRight"));

var _DateRangePickerInput = _interopRequireDefault(require("./DateRangePickerInput"));

var _moment = _interopRequireDefault(require("moment"));

require("moment-timezone");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line


var isValidDateRange = function isValidDateRange(value) {
  var start = _moment["default"].isMoment(value.start) ? value.start : (0, _moment["default"])(value.start);
  var end = _moment["default"].isMoment(value.end) ? value.end : (0, _moment["default"])(value.end);
  return end.isAfter(start);
};

var DateRangePickerWithLabel = function DateRangePickerWithLabel(_ref) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      onChange = _ref.onChange,
      timeZone = _ref.timeZone,
      label = _ref.label,
      required = _ref.required,
      styles = _ref.styles;
  var rightLabel = !isValidDateRange(value) ? "invalid date range" : "";
  return _react["default"].createElement("div", {
    className: "form-group",
    id: "event-date-form-group"
  }, _react["default"].createElement(_BestLabelWithRight["default"], {
    name: "date-range-picker",
    label: label,
    rightLabel: rightLabel,
    required: required
  }), _react["default"].createElement(_DateRangePickerInput["default"], {
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    timeZone: timeZone,
    onChange: onChange,
    styles: styles
  }));
};

DateRangePickerWithLabel.propTypes = {
  /** value of the date range picker */
  value: _propTypes["default"].shape({
    start: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    end: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired,

  /** min date allowed to selected */
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),

  /** max date allowed to selected */
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),

  /** time zones of the dates  */
  timeZone: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),

  /** styles object to override date picker */
  styles: _propTypes["default"].shape({
    icon: _propTypes["default"].shape({
      hoverColor: _propTypes["default"].string,
      size: _propTypes["default"].string,
      color: _propTypes["default"].string
    }),
    datepicker: _propTypes["default"].object
  }),

  /**  Label of the Date Range Picker*/
  label: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),

  /**  if the date range picker is required */
  required: _propTypes["default"].bool
};
DateRangePickerWithLabel.defaultProps = {
  minDate: (0, _moment["default"])(new Date("1/1/2011").valueOf()),
  maxDate: (0, _moment["default"])(new Date("1/1/2050").valueOf()),
  timeZone: _moment["default"].tz !== undefined ? _moment["default"].tz.guess() : "America/New_York",
  required: false,
  label: "Date Range",
  styles: {
    icon: {},
    datepicker: {}
  }
};
var _default = DateRangePickerWithLabel;
exports["default"] = _default;